export default __webpack_public_path__ + "static/media/img1.91c82989.jpeg";